module.exports = __webpack_public_path__ + "assets/img/vs-icon.72daacd6.png";